import { authFetch } from './client';

// `owner` (optional) reads the agent state of a project shared by another user.
export const getWorkflowAgentState = (projectId, owner) =>
  authFetch(
    `/api/projects/${projectId}/workflow-agent-state${owner ? `?owner=${encodeURIComponent(owner)}` : ''}`
  );

// Partial update. `update` is any combination of:
//   { problemBrief: string }
//   { tileStateUpdate: { tileId, state } }
//   { appendEvents: [event, ...] }
// All three are optional. The backend merges server-side, avoiding the
// read-modify-write race the prior full-replace shape suffered from.
export const saveWorkflowAgentState = (projectId, update) =>
  authFetch(`/api/projects/${projectId}/workflow-agent-state`, {
    method: 'PUT',
    body: JSON.stringify(update),
  });
